import { ThreeDots } from 'react-loader-spinner';
import { Link } from 'react-router-dom';

import { HeadlineProps } from 'components/Headline';
import { IconName } from 'components/Icon';

import { StyledButtonIconProps, StyledButtonProps, StyledLabelProps } from './Button.styles';
import * as S from './Button.styles';

type ButtonItem = {
  asLink?: boolean;
  to?: string;
  // React Router state to pass along when rendering as Link
  state?: unknown;
  onClick?: () => void;
  iconLeft?: IconName;
  iconRight?: IconName;
  testID?: string;
  type?: 'button' | 'submit';
  className?: string;
  $isInline?: boolean;
  isLoading?: boolean;
  loadingColor?: string;
  isBreadcrumbs?: boolean;
};

export type ButtonProps = React.DetailedHTMLProps<
  React.ButtonHTMLAttributes<HTMLButtonElement>,
  HTMLButtonElement
> &
  StyledButtonProps &
  StyledButtonIconProps &
  ButtonItem &
  StyledLabelProps &
  Partial<HeadlineProps>;

export function Button(props: ButtonProps): React.ReactElement {
  const {
    children,
    onClick = undefined,
    to = undefined,
    motive = 'default',
    scale = 's',
    asLink = false,
    iconLeft = undefined,
    iconRight = undefined,
    className = undefined,
    $isInline = false,
    disabled = false,
    testID = undefined,
    icoarea = undefined,
    fontFamily = 'LFT Zeno Condensed',
    textTransform = 'uppercase',
    fontWeight = 'normal',
    textAlign = 'left',
    whiteSpace = 'nowrap',
    isFlexStretch = false,
    isLoading = false,
    loadingColor = 'white',
    state = undefined,
    isBreadcrumbs = false,
    lineHeight = undefined,
    truncate = false,
    ref, // eslint-disable-line
    ...rest
  } = props;

  return (
    <S.Button
      data-testid={testID || 'button'}
      disabled={isLoading || disabled}
      $isInline={$isInline}
      className={`${className || ''} ${disabled ? 'disabled' : ''}`}
      to={disabled ? '' : to}
      as={to && asLink ? Link : 'button'}
      onClick={isLoading ? () => null : onClick}
      motive={motive}
      scale={scale}
      state={state as any}
      title={truncate && typeof children === 'string' ? children : undefined}
      {...rest}
    >
      {isLoading ? (
        <ThreeDots width={25} color={loadingColor} />
      ) : (
        <>
          {iconLeft && <S.IconLeft className="icon-left" icoarea={icoarea} name={iconLeft} />}

          {children && (
            <S.Label
              fontFamily={fontFamily}
              textTransform={textTransform}
              textAlign={textAlign}
              fontWeight={fontWeight}
              tag="span"
              color="inherit"
              scale={scale}
              whiteSpace={whiteSpace}
              isFlexStretch={isFlexStretch}
              isBreadcrumbs={isBreadcrumbs}
              lineHeight={lineHeight}
              truncate={truncate}
            >
              {children}
            </S.Label>
          )}

          {iconRight && (
            <S.IconRight className="icon-right" icoarea={icoarea} name={iconRight} />
          )}
        </>
      )}
    </S.Button>
  );
}
